module.exports = __webpack_public_path__ + "static/media/micellaneous.580f379f.svg";